import styled from "styled-components";

const Container = styled.div`
	margin-bottom: 13px;
`;

const Item = styled.div`
	padding: 10px;
	min-width: 240px;
`;

export { Container, Item };
